









import Vue from 'vue';

import Controls from './Controls/Controls.vue';
import Patterns from './Patterns/Patterns.vue';

// Styles
import '../styles/reset.css';
import '../styles/fonts.css';

export default Vue.extend({
  name: 'Tracker',
  components: {
    Controls,
    Patterns
  }
});
